<template>
  <IconButton
    :icon="iconProperties.icon"
    :color="iconProperties.color"
    :tooltip="iconProperties.tooltip"
    :small="small"
    :loading="processing"
    float
    @click="click"
    @mouseover.native="getReserver()"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    small: {
      type: Boolean,
      default: false
    },
    reserveDate: {
      type: Object,
      default: () => {}
    },
    rollingDate: {
      type: Object,
      default: () => {}
    },
    currentDatetime: {
      type: Object,
      default: () => {}
    },
    campsiteID: {
      type: String,
      default: ''
    },
    openDate: {
      type: Object,
      default: () => {}
    },
    closeDate: {
      type: Object,
      default: () => {}
    },
    blackouts: {
      type: Object,
      default: () => {}
    },
    bookings: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      reserver: false,
      processing: false
    }
  },
  computed: {
    ...mapGetters({
      authenticated: 'person/authenticated',
      person: 'person/person'
    }),
    unrestricted () {
      return this.assertSetting('miscReservationUnrestricted', 1)
    },
    booking () {
      return this.bookings?.[this.reserveDate.format('YYYY-MM-DD')]
    },
    reserverText () {
      return this.reserver ? `${this.reserver.firstName} ${this.reserver.lastName}` : 'someone else'
    },
    blackout () {
      return this.blackouts?.[this.reserveDate.format('YYYY-MM-DD')]
    },
    iconProperties () {
      if (this.booking) { // booked
        if (this.booking.personID === this.person.personID) { // belongs to person
          if (Number(this.booking.finalized)) { // booking finalized
            return {
              icon: 'fa-play',
              color: 'green',
              tooltip: 'You previously reserved this',
              action: null
            }
          } else { // in cart
            return {
              icon: 'fa-check',
              color: 'green',
              tooltip: 'This reservation is in your cart',
              action: this.remove
            }
          }
        } else { // belongs to someone else
          if (Number(this.booking.finalized)) { // booking finalized
            return {
              icon: this.assertSetting('personLoad', 1) ? 'fa-stop' : 'fa-times',
              color: 'red',
              tooltip: 'This is already reserved by ' + this.reserverText, // get reserver
              action: this.switchToReserver
            }
          } else { // in cart
            return {
              icon: 'fa-pause',
              color: 'orange',
              tooltip: 'This is in ' + this.reserverText + '\'s cart',
              action: this.switchToReserver
            }
          }
        }
      } else if (this.blackout) { // blacked out
        if (this.blackout.blackoutTypeWord === 'Offline Only') {
          if (this.unrestricted) { // admin
            return {
              icon: 'fa-plus',
              color: 'purple',
              tooltip: this.blackout.blackoutTypeWord,
              action: this.add
            }
          } else {
            return {
              icon: 'fa-phone',
              color: 'purple',
              tooltip: this.blackout.blackoutTypeWord,
              action: null
            }
          }
        } else {
          return {
            icon: 'fa-times',
            color: 'red',
            tooltip: this.blackout.blackoutTypeWord,
            action: null
          }
        }
      } else if (this.reserveDate.isBefore(this.openDate, 'day') || this.reserveDate.isAfter(this.closeDate, 'day') || this.reserveDate.isBefore(this.currentDatetime, 'day')) { // closed
        return {
          icon: 'fa-times',
          color: 'red',
          tooltip: 'Closed',
          action: null
        }
      } else if (this.reserveDate.isAfter(this.rollingDate)) { // past rolling date
        if (this.unrestricted) { // admin
          return {
            icon: 'fa-plus',
            color: 'purple',
            tooltip: 'Not available for online reservations yet',
            action: this.add
          }
        } else {
          return {
            icon: 'fa-calendar',
            color: 'orange',
            tooltip: 'Not available for online reservations yet',
            action: null
          }
        }
      } else { // good to reserve
        return {
          icon: 'fa-plus',
          color: 'blue',
          tooltip: 'Click to reserve',
          action: this.add
        }
      }
    }
  },
  methods: {
    ...mapActions({
      getCampsiteReserver: 'facilities/getCampsiteReserver',
      setProxyPerson: 'person/setProxyPerson',
      newNotification: 'info/newNotification',
      getCampsiteWeek: 'facilities/getCampsiteWeek',
      createCampsiteBooking: 'cart/createCampsiteBooking',
      deleteCampsiteBooking: 'cart/deleteCampsiteBooking'
    }),
    getReserver () {
      if (this.assertSetting('personLoad', '1') && this.booking && !this.reserver) {
        this.getCampsiteReserver({ personID: this.booking.personID }).then((response) => {
          this.reserver = response.data
        })
      }
    },
    click () {
      if (this.iconProperties.action) {
        this.processing = true
        this.iconProperties.action()
      }
    },
    add () {
      if (!this.authenticated) {
        this.newNotification({ message: 'You must be logged in to reserve.' })
      } else if (!this.assertSetting('campingOpen', 1)) {
        this.newNotification({ message: 'Online camping reservations are currently closed. Please call the office to make a reservation.' })
      } else {
        this.createCampsiteBooking({ campsiteID: this.campsiteID, date: this.reserveDate.format('YYYY-MM-DD') }).finally(this.reload)
      }
    },
    remove () {
      this.deleteCampsiteBooking({ campsiteBookingID: this.booking.campsiteBookingID }).finally(this.reload)
    },
    reload () {
      return this.getCampsiteWeek().finally(() => {
        this.processing = false
      })
    },
    switchToReserver () {
      if (this.reserver) {
        this.setProxyPerson(this.reserver)
      }
    }
  }
}
</script>
